import { useNavigate, useLocation, Navigate, LoaderFunction, LoaderFunctionArgs, redirect } from "react-router-dom";
import { useAuth, AuthState} from "react-oidc-context";
import { useEffect, useRef, useState } from "react";

import { User } from "oidc-client-ts"

type PrivateRouteProps = {
  children? : any;
  redirect_login?: boolean
}

// Check for oidc client user in storage
const loadUserFromStorage = () => {
  for (let i = 0; i < window.localStorage.length; i++) {
    if (localStorage?.key(i)?.startsWith("oidc.user")) {
      const userString = localStorage.getItem(localStorage.key(i)!);
      return User.fromStorageString(userString!);
    }
  }
  return null;
};

// Private Loader Wrapper, wraps existing loaders and redirects if auth is not valid
// Similar to example - https://reactrouter.com/en/main/fetch/redirect
export const PrivateLoader = (loaderArgs: LoaderFunctionArgs, loader: LoaderFunction) => {
  if(!loadUserFromStorage()){
    return redirect('/login')
  }
  return loader(loaderArgs);
}

export const PrivateRoute = ({ children, redirect_login = false }: PrivateRouteProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const auth = useAuth();

  // Effect redirection depending on auth state

  // Effect to do transitions to other pages or signin redirects
  useEffect(() => {
    // Redirect if not loading and not authenticated
    if (!auth.isLoading && !auth.isAuthenticated && redirect_login){
      auth.signinRedirect({redirect_uri: `${window.location.origin}${location.pathname}`});
    // No auth, redirect disabled, go to login page
    }else if(!auth.isLoading && !auth.isAuthenticated && !redirect_login){
      navigate('/login')
    }
  },[auth, location]);
  
  if (auth.isLoading && !auth.isAuthenticated){
    return(<div>Loading...</div>);
  // Auth finished, display target page
  }else if (auth.isAuthenticated){
    return(children);
  // No auth, redirect enabled, go to auth provider directly
  }else if (redirect_login){
    return(<div>Loading...</div>);
  // No auth, redirect disabled, go to login page
  }else{
    return(<div>Loading...</div>);
  }
};


export default PrivateRoute;
